import { render, staticRenderFns } from "./CheckListBtn.vue?vue&type=template&id=b1c8d452&scoped=true&"
import script from "./CheckListBtn.vue?vue&type=script&lang=js&"
export * from "./CheckListBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c8d452",
  null
  
)

export default component.exports